var React = require('react');

function Ltc (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M52.305 43.372l10.91-4.062L60.83 49.67l-11.268 4.123L45 71.132H81.48L77.563 85H19.925L26 62.414l-8 2.927 1.997-9.94 8.768-3.265L38.755 15H59.77l-7.465 28.372z"}));
}

Ltc.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = Ltc;

Ltc.default = Ltc;
